import styled from 'styled-components';

export const PreviewMapContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
